import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CATEGORIES = [
  { name: "Fuel Injector Sets", to: "/shop/Fuel%20Injector%20Sets", accent: true, image: "https://i.ebayimg.com/images/g/PfYAAeSwANdp4X1f/s-l1600.webp" },
  { name: "Single Fuel Injectors", to: "/shop/Single%20Fuel%20Injectors", image: "https://i.ebayimg.com/images/g/RUgAAeSwg11qJd3-/s-l1600.webp" },
  { name: "OEM Fuel Injectors", to: "/shop/OEM%20Fuel%20Injectors", image: "https://i.ebayimg.com/images/g/mkIAAeSwLfdqJd3A/s-l1600.webp" },
  { name: "Remanufactured Injectors", to: "/shop/Remanufactured%20Injectors", image: "https://i.ebayimg.com/images/g/r5QAAeSwM4Zp8wX0/s-l1600.webp" },
  { name: "Direct-Injection Injectors", to: "/shop/Direct-Injection%20Injectors", image: "https://i.ebayimg.com/images/g/ZekAAeSwEeNp4X1f/s-l1600.webp" },
  { name: "Port Fuel Injectors", to: "/shop/Port%20Fuel%20Injectors", image: "https://i.ebayimg.com/images/g/HMoAAeSwrmRp4X1c/s-l1600.webp" },
  { name: "Upgraded Injectors", to: "/shop/Upgraded%20Injectors", image: "https://i.ebayimg.com/images/g/hG0AAeSwm0hqJd3X/s-l1600.webp" },
  { name: "Products With Test Reports", to: "/shop/Products%20With%20Test%20Reports", image: "https://i.ebayimg.com/images/g/WC0AAOSwZL1lupUO/s-l1600.webp" },
  { name: "Domestic Applications", to: "/shop/Domestic%20Applications", image: "https://i.ebayimg.com/images/g/P-kAAeSwJ2RqJd2E/s-l1600.webp" },
  { name: "European Applications", to: "/shop/European%20Applications", image: "https://i.ebayimg.com/images/g/QvsAAeSwxYdp4X1g/s-l1600.webp" },
  { name: "Asian Applications", to: "/shop/Asian%20Applications", image: "https://i.ebayimg.com/images/g/NhsAAeSwkPxqJd37/s-l1600.webp" },
  { name: "Automotive Tools", to: "/shop/Automotive%20Tools", image: "https://i.ebayimg.com/images/g/XaUAAeSwzy5p4X1e/s-l1600.webp" },
];

export default function CategoryGrid() {
  return (
    <section data-testid="home-categories" className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">Categories</div>
            <h2 className="mt-2 font-heading text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">Shop by Category</h2>
          </div>
          <Link to="/shop" className="text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1">
            All products <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {CATEGORIES.map((c, i) => (
            <Link
              key={c.name}
              to={c.to}
              data-testid={`category-card-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative rounded-xl border border-slate-200 bg-white overflow-hidden ici-card-lift ici-fade-up"
              style={{ animationDelay: `${(i % 4) * 60}ms` }}
            >
              <div className="aspect-[5/4] bg-slate-50 relative overflow-hidden">
                <img src={c.image} alt="" loading="lazy" className="ici-img-zoom absolute inset-0 w-full h-full object-contain p-6" />
                {c.accent && (
                  <div className="absolute top-3 left-3 text-[9px] font-mono uppercase tracking-widest text-[#0055FF] bg-[#0055FF]/10 border border-[#0055FF]/20 rounded px-2 py-0.5">
                    Popular
                  </div>
                )}
              </div>
              <div className="p-4 flex items-center justify-between">
                <div className="text-sm font-heading font-semibold text-slate-900">{c.name}</div>
                <ArrowRight className="w-4 h-4 text-slate-400 group-hover:text-[#0055FF] group-hover:translate-x-1 transition-all" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
